<template>
  <div class="ces_input">
    <Formfield :required="required" :helpText="helpText" :label="label">
      <div class="ces_input__rating-and-scale">
        <RatingInput
          class="ces_input__rating_input"
          v-model="inputValue"
          :pointScale="5"
          type="smileys"
          colorOrder="rtl"
          :required="required"
        />
        <div class="ces_input__scale">
          <span class="body2">
            {{ veryDifficultLabel }}
          </span>
          <span class="body2">
            {{ veryEasyLabel }}
          </span>
        </div>
      </div>
    </Formfield>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import Formfield from "../molecules/Formfield.vue";
import RatingInput from "../molecules/RatingInput.vue";
import InputBase from "../atoms/Inputs/mixins/InputBase";
import FormMixin from "../mixins/FormMixin";

/**
 * @group Inputs
 * CES Question with a Formfield wrapped around it.
 * See CesQuestion and Formfield documentation for clearer explanation of the props.
 * This component just passes its props on.
 */
export default {
  name: "CesQuestion",
  mixins: [BaseComponent, InputBase, FormMixin],
  components: {
    RatingInput,
    Formfield,
  },
  props: {
    // The Question
    label: {
      type: String,
      required: true,
    },
    // The Hint
    helpText: {
      type: String,
    },
    required: {
      type: Boolean,
      default: true,
    },
    veryDifficultLabel: {
      type: String,
      default: "very difficult",
    },
    veryEasyLabel: {
      type: String,
      default: "very easy",
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.ces_input {
  width: 100%;
  max-width: 576px;

  .ces_input__rating-and-scale {
    width: 100%;
    max-width: 376px;
  }
  .ces_input__scale {
    display: flex;
    width: 100%;
    justify-content: space-between;
    color: $grey_french;
    margin-top: 4px;
  }
}
</style>
